import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import "../panel/userPanel.css";

export default function UploadShort() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));

  const userId = user?._id;
  const channelId = user?.channelId;

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [hashtags, setHashtags] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  // ?? video select
  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setVideoFile(file);
    if (file) setVideoPreview(URL.createObjectURL(file));
  };

  // ?? get video duration
  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);
        resolve(Math.floor(video.duration));
      };

      video.src = URL.createObjectURL(file);
    });
  };

  // ?? generate thumbnail (Flutter ????)
  const generateThumbnail = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      const canvas = document.createElement("canvas");

      video.src = URL.createObjectURL(file);
      video.currentTime = 1;

      video.onloadeddata = () => {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(
          (blob) => {
            resolve(blob);
          },
          "image/jpeg",
          0.9
        );
      };
    });
  };

  // ?? upload video
  const uploadVideo = async () => {
    const formData = new FormData();
    formData.append("content", videoFile);
    formData.append("folderStructure", "sharevideo/Shorts");

    const res = await api.put("/client/file/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data?.data || res.data?.url || res.data;
  };

  // ??? upload thumbnail (FIXED)
  const uploadThumbnail = async () => {
    const thumbnailBlob = await generateThumbnail(videoFile);

    const formData = new FormData();
    formData.append("content", thumbnailBlob, "thumbnail.jpg"); // ?? IMPORTANT
    formData.append("folderStructure", "sharevideo/shortsImage");

    const res = await api.put("/client/file/upload-file", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data?.data || res.data?.url || res.data;
  };

  // ?? upload
  const handleUpload = async () => {
    if (!title || !description || !hashtags || !videoFile) {
      alert("Please fill all required fields");
      return;
    }

    if (!userId || !channelId) {
      alert("Channel not created. Please create channel first.");
      return;
    }

    try {
      setLoading(true);

      const duration = await getVideoDuration(videoFile);

      if (!duration || duration <= 0) {
        alert("Invalid video duration");
        return;
      }

      const hashTagArray = hashtags
        .split(" ")
        .map((tag) => tag.replace("#", "").trim())
        .filter(Boolean);

      const videoUrl = await uploadVideo();
      const thumbnailUrl = await uploadThumbnail();

      console.log("FINAL:", {
        videoUrl,
        thumbnailUrl,
        duration,
      });

      await api.post("/client/video/createVideo", {
        title,
        description,
        hashTag: hashTagArray,
        videoType: 2,
        videoTime: duration,
        visibilityType: 1,
        audienceType: 1,
        commentType: 1,
        scheduleType: 2,
        location: "",
        latitude: "0",
        longitude: "0",
        userId,
        channelId,
        fullName: user?.fullName || "",
        descriptionOfChannel: "",
        videoUrl,
        videoImage: thumbnailUrl,
        videoPrivacyType: 1,
        channelType: "1",
        isShort: true,
      });

      alert("Short uploaded successfully");
      navigate("/user/videos-feed");

    } catch (err) {
      console.error("Upload error:", err?.response?.data || err);
      alert("Short upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="upload-container">
      <div className="upload-card">
        <h2>Upload Short</h2>

        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            className="form-input"
            placeholder="Add a title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Description *</label>
          <textarea
            className="form-textarea"
            placeholder="Add description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Hashtags *</label>
          <input
            type="text"
            className="form-input"
            placeholder="#shorts #viral"
            value={hashtags}
            onChange={(e) => setHashtags(e.target.value)}
          />
        </div>

        <div className="form-group">
          <label>Short Video *</label>
          <input type="file" accept="video/*" onChange={handleVideoChange} />
        </div>

        {videoPreview && (
          <video
            src={videoPreview}
            controls
            style={{ width: "100%", marginTop: 10 }}
          />
        )}

        <button onClick={handleUpload} disabled={loading}>
          {loading ? "Uploading..." : "Upload Short"}
        </button>
      </div>
    </div>
  );
}